// extracted by mini-css-extract-plugin
export default {"imageBack":"styles_imageBack__ZesTl","imageBackMobile":"styles_imageBackMobile__wi4kK","zeroPadding":"styles_zeroPadding__p6B+K","buttonSend":"styles_buttonSend__tR+8S"};